import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, CalendarDays } from "lucide-react";
import SectionHeader from "@/components/shared/SectionHeader";
import { COHORTS } from "@/lib/data";

const EISGCohorts = () => (
  <div>
    <section className="py-28 lg:py-36 bg-[#0A192F] text-white grain">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="overline text-[#D4AF37] mb-6">— Calendrier des cohortes</div>
        <h1 className="font-eisg text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] max-w-4xl">
          Cohortes <span className="text-[#D4AF37]">2026 – 2027.</span>
        </h1>
        <p className="mt-8 text-lg sm:text-xl text-white/75 max-w-3xl leading-relaxed">
          Un calendrier pensé pour créer de la valeur à chaque niveau de décision et d'exécution.
        </p>
      </div>
    </section>

    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 space-y-px bg-[#0A192F]/10">
        {COHORTS.map((c, i) => (
          <div key={c.period} className="bg-white grid lg:grid-cols-12 gap-8 p-10 lg:p-14 items-center lift-card">
            <div className="lg:col-span-2">
              <div className="font-eisg text-7xl text-[#D4AF37] leading-none">{String(i + 1).padStart(2, "0")}</div>
            </div>
            <div className="lg:col-span-4">
              <div className="flex items-center gap-2 overline text-[#0A192F]/60">
                <CalendarDays size={14} /> Période
              </div>
              <div className="mt-2 font-eisg text-2xl text-[#0A192F]">{c.period}</div>
              <div className="mt-3 inline-flex items-center gap-2 text-sm text-[#0A192F]/70">
                <MapPin size={14} className="text-[#F58220]" /> {c.location}
              </div>
            </div>
            <div className="lg:col-span-4">
              <div className="overline text-[#F58220]">{c.programme}</div>
              <h3 className="mt-2 font-bd text-xl text-[#0A192F] leading-snug">{c.subtitle}</h3>
            </div>
            <div className="lg:col-span-2 text-right">
              <Link to="/eisg/registration" className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#0A192F] hover:text-[#F58220] link-underline">
                Pré-inscription <ArrowRight size={14} />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className="py-20 bg-[#FAFAFA] border-t border-[#0A192F]/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
        <p className="font-eisg text-2xl sm:text-3xl text-[#0A192F] tracking-tight max-w-3xl mx-auto">
          Un calendrier exécutif pour piloter, commander et augmenter vos métiers.
        </p>
      </div>
    </section>
  </div>
);

export default EISGCohorts;
